"use strict";

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std */
//================================================================

var _InsertIterator_1 = require("../base/iterator/_InsertIterator");

var comparators_1 = require("../functional/comparators");
/**
 * Insert iterator.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var InsertIterator =
/** @class */
function (_super) {
  __extends(InsertIterator, _super);
  /* ---------------------------------------------------------
      METHODS
  --------------------------------------------------------- */

  /**
   * Initializer Constructor.
   *
   * @param container Target container to insert.
   * @param it Iterator to the position to insert.
   */


  function InsertIterator(container, it) {
    var _this = _super.call(this) || this;

    _this.container_ = container;
    _this.it_ = it;
    return _this;
  }

  Object.defineProperty(InsertIterator.prototype, "value", {
    /**
     * @inheritDoc
     */
    set: function set(val) {
      this.it_ = this.container_.insert(this.it_, val);
      this.it_ = this.it_.next();
    },
    enumerable: true,
    configurable: true
  });
  /**
   * @inheritDoc
   */

  InsertIterator.prototype.equals = function (obj) {
    return comparators_1.equal_to(this.it_, obj.it_);
  };

  return InsertIterator;
}(_InsertIterator_1._InsertIterator);

exports.InsertIterator = InsertIterator;